export default __webpack_public_path__ + "379df5d97b717b451bb85a4fac637df3.png";